<div class="container">
  @if (showToolbar()) {
    <app-home-toolbar />
  }
  <div class="home-content" [class.home-content--welcome]="!showToolbar()">
    <router-outlet />
  </div>
</div>
